import React from 'react'
import styles from './splash-screen.module.scss'
import logo from 'src/assets/brand/GTO_GRN.svg'

const SplashScreen = () => {
  return (
    <div className={`background-color-dark ${styles['comingsoon-container']}`}>
      <img src={logo} alt="GTO" />
      <h2 className={styles['gto-label__color']}>Global Trade Optimizer</h2>
      <p className={`${styles['gto-label__color']} p-2`}>Loading...</p>
    </div>
  )
}

export default SplashScreen
